module.exports = __webpack_public_path__ + "static/media/japan-cover.2a0baed7.jpg";